var exports = {
  "kL": "xa15a2ab7--4e29d5--container",
  "nV": "xa15a2ab7--4e29d5--gallery",
  "_8": "xa15a2ab7--4e29d5--img",
  "hJ": "xa15a2ab7--4e29d5--counter",
  "h_": "xa15a2ab7--4e29d5--description",
  "DD": "xa15a2ab7--4e29d5--title",
};

module.exports = exports;
